import React, { useState } from "react";
import "./styles.scss";
import logo from "../../images/bitcoin-live/logo.png";
import lock from "../../images/bitcoin-live/lock.png";
import Carousel from "../../components/common/Carousel";
import AnalystCarouselCard from "../../components/common/AnalystCarouselCard";
import { analysts } from "./analystsJson";
import Layer16 from "../../images/bitcoin-live/Layer16.png";
import Layer15 from "../../images/bitcoin-live/Layer15.png";
import Layer14 from "../../images/bitcoin-live/Layer14.png";
import Dice from "../../images/bitcoin-live/Dice.png";
import Layer5 from "../../images/bitcoin-live/Layer5.png";
import Layer3 from "../../images/bitcoin-live/Layer3.png";
import Layer6 from "../../images/bitcoin-live/Layer6.png";
import Layer7 from "../../images/bitcoin-live/Layer7.png";
import Layer8 from "../../images/bitcoin-live/Layer8.png";
import Layer17 from "../../images/bitcoin-live/Layer17.png";
import Phone from "../../images/bitcoin-live/Phone.png";
import traderImg from "../../images/bitcoin-live/TraderPhoto.png";
import bob_avatar from "../../images/bitcoin-live/bob_avatar.jpg";
import { Modal, ModalHeader, ModalBody } from "../../components/ui";
import PlansCards from "../../components/common/PlansCards";
import MainFooter from "../../components/layout/MainFooter";
import TestimonialsCarousel from "../../components/common/TestimonialsCarousel";
import { testinomials } from "./testimonial";
import CheckLogin from "../../components/common/CheckLogin";

const LandingPage = () => {
  const rightArrow = {
    fontSize: "17px",
    position: "relative",
    top: "1px",
    color: "#fff",
  };
  const [modal, setModal] = useState(false);
  const [url, setUrl] = useState("");
  const galleryBreakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 850, itemsToShow: 3 },
    { width: 1150, itemsToShow: 3 },
    { width: 1450, itemsToShow: 3.1 },
    { width: 1750, itemsToShow: 4.1 },
    { width: 2000, itemsToShow: 5.1 },
  ];

  return (
    <div className="parentDiv">
      <CheckLogin />
      <div className="headerDiv">
        <img style={{ position: "absolute" }} src={logo} alt="bitcoin" />
        <label className="textStyle">
          Bitcoin
          <br /> Live
        </label>
        <div className="buttonDiv">
          <a href="/blogs/public">
            <button className="btnStyles">
              <img className="lockImg" src={lock} alt="" />
              Public Area
            </button>
          </a>
          <a href="/blogs/premium">
            <button className="btnStyles">
              <img className="lockImg" src={lock} alt="" />
              Member's Area
            </button>
          </a>
        </div>
      </div>
      <div className="header2">
        <div style={{ width: window.screen.width < 500 ? "100%" : "50%" }}>
          <label className="text1">99% of Crypto Traders Lose Money.</label>
          <br />
          <label className="text2">Learn To Be In the 1%.</label>
          <label className="text3">
            <b style={{ color: "#fff", fontWeight: 200, opacity: 0.8 }}>
              {" "}
              Learn & profit through an exclusive educational platform run by{" "}
            </b>
            <b style={{ color: "#fff" }}>
              {" "}
              8 of the world’s leading crypto traders.
            </b>
          </label>
          <div style={{ display: window.screen.width < 500 ? "flex" : {} }}>
            <button
              onClick={() => {
                const element = document.getElementById("plans");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
              className="joinBtn"
            >
              Join Now <i class="fa fa-caret-right" style={rightArrow}></i>
            </button>
            <label
              onClick={() => {
                const element = document.getElementById("scrollTo");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
              className="joinlink"
              style={{ cursor: "pointer" }}
            >
              Why Join Bitcoin Live?
            </label>
          </div>
        </div>
        <div className="blVideo">
          <div
            style={{
              height: window.screen.width > 500 ? "318px" : "200px",
              outline: "#fff",
              outlineStyle: "solid",
              outlineWidth: "1px",
              width: window.screen.width > 1000 ? "572px" : "100%",
            }}
            className={"wistia_embed wistia_async_fwaxun2z59"}
          ></div>
          <TestimonialsCarousel
            testimonials={testinomials}
            variant="hero"
            autoplayMs={5000}
          />
        </div>
      </div>
      <div className="tradeDiv">
        <div className="tradeHeader">
          Meet the{" "}
          <img
            style={{ marginBottom: 10, height: 26 }}
            src={logo}
            alt="bitcoin"
          />{" "}
          bitcoin live traders{" "}
          <label style={{ opacity: "0.8", marginBottom: 0 }}>
            (& your future mentors)
          </label>
        </div>
      </div>
      <div className="traders-showcase">
        <Carousel
          transitionMs={2000}
          breakPoints={galleryBreakPoints}
          pagination={false}
        >
          {analysts.map((data) => (
            <AnalystCarouselCard
              key={data.name}
              analyst={data}
              onIntroClick={(videoId) => {
                setModal(true);
                setUrl(videoId);
              }}
            />
          ))}
        </Carousel>
        <Modal
          centered={true}
          size="md"
          isOpen={modal}
          toggle={() => {
            setModal(false);
          }}
          style={{
            minWidth: window.screen.width > 500 ? "684px" : "auto",
          }}
        >
          <ModalHeader
            toggle={() => {
              setModal(false);
            }}
            style={{ border: "none", padding: "8px 16px" }}
          ></ModalHeader>
          <ModalBody style={{ padding: "0 16px 16px 16px" }}>
            <div
              style={{ height: window.screen.width > 500 ? "400px" : "220px" }}
            >
              <div
                style={{ height: "100%" }}
                className={`wistia_embed wistia_async_${url}`}
              ></div>
            </div>
          </ModalBody>
        </Modal>
      </div>
      <div className="lightLayer">
        <div className="infoDiv">
          <label className="titleText">What is Bitcoin Live?</label>
          <p className="Pcontent">
            Bitcoin Live is an exclusive educational platform run by{" "}
            <b style={{ color: "black", fontWeight: "bold", opacity: 1 }}>
              {" "}
              8 veteran traders
            </b>{" "}
            who have now turned their focus to the crypto market. Its goal is to
            provide you with the knowledge, tools & techniques to
            <b style={{ color: "black", fontWeight: "bold", opacity: 1 }}>
              {" "}
              profitably
            </b>{" "}
            trade Bitcoin & other cryptocurrencies.
            <br />
            <br /> Over the last 5 years, Bitcoin Live members have harnessed
            the experience & trading wisdom of Peter Brandt, Bob Loukas, and the
            rest of the Bitcoin Live team to
            <b style={{ color: "black", fontWeight: "bold", opacity: 1 }}>
              {" "}
              successfully navigate multiple bull & bear markets.
            </b>
          </p>
          <div className="benefits">
            <label
              className="name"
              style={{
                marginBottom: 50,
                letterSpacing: "6px",
                fontWeight: 400,
              }}
            >
              MEMBERSHIP BENEFITS
            </label>
            <br />
            <label className="infoTitle">
              Bitcoin Live’s 8 expert trader’s will:
            </label>
            <div
              style={{
                display: "flex",
                width: "100%",
              }}
            >
              <div className="icons">
                <img src={Layer16} />
                <br />
                <label className="infoSubTitle">
                  Answer Your Trading Questions
                </label>
              </div>
              <div className="icons">
                <img src={Layer15} /> <br />
                <label className="infoSubTitle">
                  Give You Weekly Market Updates
                </label>
              </div>
              <div className="icons">
                <img src={Layer14} /> <br />
                <label className="infoSubTitle">
                  Share Their Insight & How To Guides
                </label>
              </div>
            </div>
            <label className="infoTitle">Also, they’ll teach you:</label>
            <div
              style={{
                display: "flex",
                width: "100%",
              }}
            >
              <div className="icons">
                <img src={Dice} />
                <br />
                <label className="infoSubTitle">
                  Effective Risk Management
                </label>
              </div>
              <div className="icons">
                <img style={{ height: "60px" }} src={Layer5} /> <br />
                <label className="infoSubTitle">
                  Pro Technical Analysis{""} {""}
                </label>
              </div>
              <div className="icons">
                <img
                  style={{ width: window.screen.width < 500 ? "75px" : {} }}
                  src={Layer3}
                />{" "}
                <br />
                <label className="infoSubTitle">
                  Bull & Bear Market Strategies
                </label>
              </div>
            </div>
            <label className="infoTitle">
              Plus, you’ll have access to their:
            </label>
            <div
              style={{
                display: "flex",
                width: "100%",
              }}
            >
              <div className="icons">
                <img src={Layer8} />
                <br />
                <label className="infoSubTitle">Trading Tips & Secrets</label>
              </div>
              <div className="icons">
                <img src={Layer6} /> <br />
                <label className="infoSubTitle">Real-Time Trade Alerts</label>
              </div>
              <div className="icons">
                <img src={Layer7} /> <br />
                <label className="infoSubTitle">Live Events & Webinars</label>
              </div>
            </div>
            <button
              onClick={() => {
                const element = document.getElementById("plans");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
              className="joinBtn"
              style={{
                margin: window.screen.width > 500 ? "4% 30%" : "4% 20%",
              }}
            >
              Join Now <i class="fa fa-caret-right" style={rightArrow}></i>
            </button>
          </div>
        </div>
        <div className="mobileDiv">
          <img src={Phone} />
          <label className="sampleHeader">
            GET YOUR TRADING QUESTIONS ANSWERED...
          </label>
          <div className="analystReplies">
            <img style={{ marginTop: 15 }} src={Layer17} />
            <br />
            <label className="contentSample">
              Why do you have the monthly cycle placed at 49 instead of the
              usual 47? November made a lower low too.
            </label>
            <div style={{ display: "flex", float: "right" }}>
              <div>
                <img
                  src={bob_avatar}
                  style={{
                    borderRadius: "100px",
                    width: "50px",
                    marginRight: 10,
                  }}
                />
              </div>
              <div
                style={{
                  fontFamily: "sans-serif",
                  lineHeight: "15px",
                  paddingTop: 8,
                }}
              >
                <label
                  style={{ marginBottom: 0, fontWeight: "bold", fontSize: 16 }}
                >
                  Bob Loukas
                </label>
                <br />
                <label
                  style={{ color: "#707070", fontWeight: 300, fontSize: 10 }}
                >
                  Jan-15-2023 12:32
                </label>
              </div>
            </div>
            <br />
            <div className="replyDiv">
              <label className="contentSample">
                {" "}
                Because I believe this past 60-day Cycle part of the ending move
                of a 4yr cycle that just refused to break down.
              </label>
            </div>
          </div>
        </div>
      </div>
      <TestimonialsCarousel testimonials={testinomials} variant="featured" />
      <div id="scrollTo" className="joinDiv">
        <label
          style={{
            color: "#252525",
            fontSize: 40,
            fontWeight: 600,
            marginBottom: 25,
          }}
        >
          Why Join Bitcoin Live?
        </label>
        <br />
        <label className="aboutcontent">
          In a crypto industry full of scams, charlatans & grifters, Bitcoin
          Live offers you a{" "}
          <b style={{ color: "#000", fontWeight: "bold" }}>
            {" "}
            trader’s safehaven
          </b>
          . A place on the Internet where you can hone your trading skill with
          the support of 8 veteran traders.
        </label>
        <div
          style={{
            width: "100%",
            display: window.screen.width > 500 ? "flex" : {},
            marginTop: 50,
          }}
        >
          <div style={{ width: window.screen.width > 500 ? "50%" : "100%" }}>
            <img
              width={window.screen.width > 500 ? "90%" : "100%"}
              height={window.screen.width > 500 ? 500 : "auto"}
              src={traderImg}
            />
          </div>
          <div
            style={{
              width: window.screen.width > 500 ? "50%" : "100%",
              marginTop: window.screen.width > 500 ? {} : 20,
            }}
          >
            <label className="subInfo">
              Learn to be a disciplined & profitable trader.
            </label>
            <label style={{ marginBottom: 30 }} className="aboutcontent">
              Bitcoin Live is run by the World’s leading crypto analysts.
              They’ve put together 100s of hours of videos, articles, webinars &
              training materials to share their wisdom. All to help you become a
              long-term, profitable trader.
            </label>
            <label className="subInfo">
              Get exclusive access to expert advice.
            </label>
            <label style={{ marginBottom: 30 }} className="aboutcontent">
              The analysts have over one-hundred years of cumulative trading
              experience. They’ve navigated the entire spectrum of trading
              environments, and pass on their knowledge & decision making skills
              to Bitcoin Live members.
            </label>
            <label className="subInfo">
              Benefit from ‘over-the-shoulder’ trades.
            </label>
            <label style={{ marginBottom: 30 }} className="aboutcontent">
              As a member, not only will you learn from the experts, but you’ll
              also be in the unique position to see their actual trades too!
            </label>
            <button
              id="plans"
              style={{
                margin: window.screen.width > 500 ? "4% 30%" : "0% 21%",
              }}
              onClick={() => {
                const element = document.getElementById("plans");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
              className="joinBtn"
            >
              Join Now <i class="fa fa-caret-right" style={rightArrow}></i>
            </button>
          </div>
        </div>
      </div>
      <div style={{ margin: "3% 10% 1% 10%" }}>
        <label className="plantitle">
          You’re <b style={{ color: "#F15922" }}>1 Step Away</b> From Becoming a
          Better Crypto Trader...
        </label>
        <label
          style={{
            color: "#fff",
            fontSize: window.screen.width > 500 ? "30px" : "14px",
            margin: "4% 1%",
            textAlign: "center",
            width: "100%",
          }}
        >
          Choose from one of the following subscription plans:
        </label>
        <PlansCards noPadding />
      </div>
      <div>
        <MainFooter />
      </div>
    </div>
  );
};

export default LandingPage;
